import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';

import css from './index.styl?inline';

export default registerMPElement(
  `mp-file-uploader`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        accept: `string`,
        label: {type: `string`, default: `Select File`},
        placeholder: {type: `string`, default: `Please select a file`},
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        defaultState: {
          fileName: ``,
        },
        helpers: {
          toggleFileChange: (ev) => {
            const file = ev.currentTarget.files[0];
            if (file) {
              this.update({fileName: file.name});
              this.dispatchEvent(new CustomEvent(`change`, {detail: {file}}));
            }
          },
        },
      };
    }
  },
);
